/**
 * retuns a random number between min and max
 * 
 * @param max {number} max number
 * @param min {number} min number (default 1)
 * @returns {number} random number between min and max
 */
export function randomNumber(max : number, min : number = 1): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * retuns a random number between min and max
 * 
 * @param max {number} max number
 * @param min {number} min number (default 1)
 * @returns {number} random number between min and max
 */
export function randomHex(length: number = 16): string {
    return randomString(length, '0123456789abcdef');
}

/**
 * Generates a random alphanumeric string of the given length.
 * @param {number} length - The length of the generated string.
 * @param {string} characters - The character set to use (default: lowercase letters & numbers).
 * @returns {string} The generated random string.
 */
export function randomString(length: number = 16, characters: string = 'abcdefghijklmnopqrstuvwxyz0123456789'): string {
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
}

/**
 * Generates a random UUID.
 * @returns {string} The generated UUID.
 */
export function randomUuid(): string {
    return `${randomString(8)}-${randomString(4)}`;
}